import { axios } from "@/plugins/axios";
import { getDataString } from "@/utils";

function getDevicesForContract(contractId) {
    let data = {
        vertragsnummer: contractId,
    };
    let dataString = getDataString(data);
    return axios.post(
        "?Mode=MeinServicebereich&Function=UnwetterGetDevicesForContract",
        dataString
    );
}

function setPLZForContract(contractId, deviceid, devicetype, plz, devicename) {
    let data = {
        vertragsnummer: contractId,
        deviceid: deviceid,
        devicetype: devicetype,
        plz: plz,
        devicename: devicename,
    };
    let dataString = getDataString(data);
    return axios.post(
        "?Mode=MeinServicebereich&Function=UnwetterSetPLZForContract",
        dataString
    );
}

function removeDeviceFromContract(contractId, deviceid, devicetype) {
    let data = {
        vertragsnummer: contractId,
        deviceid: deviceid,
        devicetype: devicetype,
    };
    let dataString = getDataString(data);
    return axios.post(
        "?Mode=MeinServicebereich&Function=UnwetterRemoveDeviceFromContract",
        dataString
    );
}

function unwetterGetStatus(contractId) {
    let data = {
        vertragsnummer: contractId,
    };
    let dataString = getDataString(data);
    return axios.post(
        "?Mode=MeinServicebereich&Function=UnwetterGetStatus",
        dataString
    );
}

function unwetterSetStatus(data = {}) {
    data.mobil = data.mobil.substr(1);
    let dataString = getDataString(data);
    return axios.post(
        "?Mode=MeinServicebereich&Function=UnwetterSetStatus",
        dataString
    );
}

function unwetterDeactivate(contractId) {
    let data = {
        vertragsnummer: contractId,
    };
    let dataString = getDataString(data);
    return axios.post(
        "?Mode=MeinServicebereich&Function=UnwetterDeactivate",
        dataString
    );
}

export {
    getDevicesForContract,
    setPLZForContract,
    removeDeviceFromContract,
    unwetterGetStatus,
    unwetterSetStatus,
    unwetterDeactivate,
};
